// extracted by mini-css-extract-plugin
module.exports = {"level":"style__level__amvpw","header":"style__header__ZoLyS","buttonArea":"style__buttonArea__du++8","used":"style__used__A9HZu","content":"style__content__Hv+yv"};